/**
 * ============================================================================
 * GRATIA - assets/lightbox.js
 * ----------------------------------------------------------------------------
 * Full-screen product image lightbox built on native <dialog>. Opens from any
 * [data-lightbox-open], syncs to the clicked media, supports arrows + keyboard
 * + swipe, and traps focus via the dialog element itself.
 * ============================================================================
 */
(function () {
  'use strict';
  const dialog = document.querySelector('[data-lightbox]');
  if (!dialog || typeof dialog.showModal !== 'function') return;

  const viewport = dialog.querySelector('[data-lightbox-viewport]');
  const slides = Array.from(dialog.querySelectorAll('[data-lightbox-slide]'));
  let index = 0;

  function show(i) {
    index = (i + slides.length) % slides.length;
    slides.forEach((s, n) => s.classList.toggle('is-active', n === index));
  }

  function openAt(mediaId) {
    const i = slides.findIndex((s) => s.dataset.mediaId === String(mediaId));
    show(i > -1 ? i : 0);
    dialog.showModal();
    document.body.classList.add('no-scroll');
  }

  function close() {
    dialog.close();
    document.body.classList.remove('no-scroll');
  }

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-lightbox-open]');
    if (opener) {
      e.preventDefault();
      openAt(opener.dataset.mediaId);
    }
  });

  dialog.querySelector('[data-lightbox-close]')?.addEventListener('click', close);
  dialog.querySelector('[data-lightbox-prev]')?.addEventListener('click', () => show(index - 1));
  dialog.querySelector('[data-lightbox-next]')?.addEventListener('click', () => show(index + 1));

  dialog.addEventListener('click', (e) => {
    // click outside the image closes
    if (e.target === dialog || e.target === viewport) close();
  });

  dialog.addEventListener('cancel', () => document.body.classList.remove('no-scroll'));
  dialog.addEventListener('keydown', (e) => {
    if (e.key === 'ArrowLeft') show(index - 1);
    if (e.key === 'ArrowRight') show(index + 1);
  });

  // swipe
  let startX = 0;
  viewport?.addEventListener('touchstart', (e) => (startX = e.touches[0].clientX), { passive: true });
  viewport?.addEventListener('touchend', (e) => {
    const dx = e.changedTouches[0].clientX - startX;
    if (Math.abs(dx) > 50) show(index + (dx < 0 ? 1 : -1));
  }, { passive: true });
})();
